export const SceneKey = {
	Boot: "Boot",
	Preload: "Preload",
	Match: "Match",
} as const;

export type SceneKey = (typeof SceneKey)[keyof typeof SceneKey];
